<template>
    <div class="d-flex align-items-center">
        <span v-if="params.node.rowPinned">
            <b-button variant="default" @click="handleCancelSubscriptionClick">
                Cancel Lodgix
            </b-button>
        </span>
        <span v-else>
            <b-button variant="default" @click="handleChangeClick" v-if="displayButtons && !isWebsiteModule && !isVerificationModule">
                <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon> Change
            </b-button>
        </span>
    </div>
</template>

<script>
    export default {
        computed: {
            isWebsiteModule() {
                return this.params.data.module && this.params.data.component === 'website';
            },
            isVerificationModule() {
                return this.params.data.module && this.params.data.component === 'verification';
            },
            displayButtons: function() {
                return (
                    !this.params.subscription.is_suspended &&
                    (this.params.subscription.is_trial || this.params.subscription.payments)
                );
            },
        },
        methods: {
            async handleCancelSubscriptionClick() {
                this.params.onCancel();
            },
            async handleChangeClick() {
                if (!this.params.data.module) {
                    this.$router.push('/app/subscription/change/');
                } else {
                    this.params.onModuleChange();
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.btn) {
        width: 110px !important;
        font-size: 14px !important;
    }
</style>
